import { IBaseResponse, ILoginBody, ILoginRes, IRegisterBody, IResetPasswordBody, IVerifyBody } from 'src/types';
import { http } from 'src/utils';

export default class AuthService {
  private url = '/api/auth';

  public async login(body: ILoginBody) {
    const { data } = await http.post<ILoginRes>(`${this.url}/login`, body);
    return data;
  }

  public async register(body: IRegisterBody) {
    const { data } = await http.post<string>(`${this.url}/register`, body);
    return data;
  }

  public async verify(body: IVerifyBody) {
    const { data } = await http.post<ILoginRes>(`${this.url}/active`, body);
    return data;
  }

  public async resend(id: string) {
    const { data } = await http.get<boolean>(`${this.url}/resend/${id}`);
    return data;
  }

  public async forgotPassword(body: { username: string }) {
    const { data } = await http.post<boolean>(`${this.url}/forgot-password`, body);
    return data;
  }

  public async resetPassword(body: IResetPasswordBody) {
    const { data } = await http.post<boolean>(`${this.url}/reset-password`, body);
    return data;
  }

  public async logout() {
    const { data } = await http.get<boolean>(`${this.url}/logout`);
    return data;
  }

  public async refresh(body: any) {
    const { data } = await http.post<IBaseResponse<ILoginRes>>(`${this.url}/refresh`, body);
    return data.data;
  }
}
